import dayjs from 'dayjs'
import HandleRequestMixin from 'mixins/HandleRequestMixin'
import IndicateScrollMixin from 'mixins/IndicateScrollMixin'

export default {
    mixins: [HandleRequestMixin, IndicateScrollMixin],

    props: {
        year: { type: Number, required: true },
        month: { type: Number, required: true },
        day: { type: Number, required: true },
        isOpen: { type: Boolean, default: false },
    },

    computed: {
        stopProcessingAfterRequestFinished() {
            return true
        },

        date() {
            return dayjs().year(this.year).month(this.month).date(this.day).startOf('day')
        },
    },
}
